import { classnames } from '@aibees/shared/utils';
import { FormControlLabel, Radio, Typography } from '@mui/material';
import { memo } from 'react';
import { useTableLayoutTemplateContext } from '../../context';
import * as SX from '../table-layout-template-item/sx';
import * as Styled from './styles';
import type { TableLayoutTemplateItemProps as Props } from './types';

export const TableLayoutTemplateItemDefault = memo(({ className }: Props) => {
  const { id, templateEditItem, setId, setTemplateEditItem } =
    useTableLayoutTemplateContext();

  const isDefaultSelected = !id;

  const handleDefaultSelect = () => {
    setId(undefined);
    setTemplateEditItem(undefined);
  };

  return (
    <Styled.Wrapper
      className={classnames('TableLayoutTemplateItemDefault', className)}
      sx={SX.root(false)}
      direction="row"
      justifyContent="space-between"
    >
      <FormControlLabel
        value="default"
        control={
          <Radio
            checked={isDefaultSelected}
            value="default"
            size="small"
            disableRipple
          />
        }
        onChange={handleDefaultSelect}
        label={
          <Typography variant="body4" fontWeight={500} color="grey.600">
            Default Template
          </Typography>
        }
        sx={SX.label}
      />
    </Styled.Wrapper>
  );
});

TableLayoutTemplateItemDefault.displayName = 'TableLayoutTemplateItemDefault';
